import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../AuthContext/AuthContext'

function ProtectedRoute({ children }) {
  const { user, is2FA } = useAuth()
  const location = useLocation()

  if (!user || !is2FA) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />
  }

  return children
}

export default ProtectedRoute
